import { useMutation } from '@apollo/client'
import React, { useState } from 'react'
import { UPDATE_TICKET } from '../../../graphql/mutation'
import { toast } from 'react-toastify'
// import { GET_ALL_SUPPORT_TICKETS } from '../../../graphql/query'
import { Select } from 'antd'
import { GET_TICKET_BY_STATUS_INPUT, GET_TOTAL_NUMBER_OF_TICKET } from '../../../graphql/query'
import { v4 as uuidv4 } from 'uuid'
const { Option } = Select

interface IProps {
  closeModal: any
  updateTicketData: any
  id: any
}

const UpdateTicketModal: React.FC<IProps> = ({ closeModal, updateTicketData, id }) => {
  const [resolution, setResolution] = useState('')
  const [statusId, setStatusId] = useState<any>(updateTicketData?.StatusId)
  const [priorityId, setPriorityId] = useState<any>(updateTicketData?.PriorityId)
  const [statusError, setStatusError] = useState<boolean>(false)

  console.log(updateTicketData)

  const [updteTicket] = useMutation(UPDATE_TICKET, {
    refetchQueries: [
      {
        query: GET_TICKET_BY_STATUS_INPUT,
        variables: {
          input: {
            supportEngineerId: parseInt(id)
          }
        },
        context: {
          headers: {
            'access-control-allow-methods': 'Support-Tickets'
          }
        }
      },
      {
        query: GET_TOTAL_NUMBER_OF_TICKET,
        context: {
          headers: {
            'access-control-allow-methods': 'Support-Tickets'
          }
        }
      }
    ],
    context: {
      headers: {
        'access-control-allow-methods': 'Support-Tickets'
      }
    }
  })

  const statusOption = [
    { name: 'Open', value: 1 },
    { name: 'Resolved', value: 2 },
    { name: 'In-Progress', value: 3 }
    // { name: 'Pending', value: 4 }
  ]

  const submitHandler = async () => {
    try {
      const inputData = {
        Addresolution: resolution,
        priorityId: +priorityId,
        statusId: +statusId,
        ticketId: updateTicketData?.id
      }

      const { data } = await updteTicket({
        variables: {
          input: inputData
        },
        context: {
          headers: {
            'access-control-allow-methods': 'Support-Tickets'
          }
        }
      })
      closeModal()
      toast.success(data?.updateTicket.message)
    } catch (error) {
      console.error('Error editing ticket:', error)
    }
  }

  const changeHandler = (e: any) => {
    setResolution(e.target.value)
  }

  const typeHandler = (e: any) => {
    setStatusId(e.target.value)
    setStatusError(false)
  }

  return (
    <>
      <form
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          marginBottom: '40px',
          marginTop: '20px'
        }}
      >
        <div style={{ display: 'flex', gap: '10px', width: '100%', alignItems: 'center' }}>
          <p style={{ margin: '0', fontSize: '16px', width: '20%' }}>Resolution</p>
          <div style={{ width: '80%' }}>
            <textarea
              // value={updateTicketData?.resolution}
              onChange={changeHandler}
              style={{ width: '100%', border: '1px solid  #cccccc' }}
            />
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <p style={{ margin: '0', fontSize: '16px', width: '20%' }}>Status</p>

          <div style={{ width: '80%' }}>
            <select
              value={statusId}
              onChange={typeHandler}
              className='form-select form-select-solid form-select'
            >
              {statusOption?.map((categoryName, index) => (
                <option
                  key={uuidv4()}
                  value={categoryName?.value}
                  disabled={categoryName?.value === updateTicketData?.StatusId}
                  style={{
                    color:
                      categoryName?.value === updateTicketData?.StatusId ? '#bfbfbf' : '#666666',
                    marginBottom: '100px'
                  }}
                >
                  {categoryName?.name}
                </option>
              ))}
            </select>
            {statusError && <p style={{ color: 'red', margin: '0' }}>Status Required</p>}
          </div>
        </div>
        {/* <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <p style={{ margin: '0', fontSize: '16px', width: '20%' }}>Priority</p>
          <div style={{ width: '80%' }}>
            <select
              value={priorityId}
              onChange={priorityHandler}
              className='form-select form-select-solid form-select'
            >
              {priorityOption?.map((priorityName, index) => (
                <option
                  key={index}
                  value={priorityName?.value}
                  disabled={priorityName.value === updateTicketData?.PriorityId}
                  style={{
                    color:
                      priorityName?.value === updateTicketData?.PriorityId ? '#bfbfbf' : '#666666',
                    marginBottom: '100px'
                  }}
                >
                  {priorityName?.name}
                </option>
              ))}
            </select>
            {priorityError && <p style={{ color: 'red', margin: '0' }}>Priority Required</p>}
          </div>
        </div> */}
      </form>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <button onClick={submitHandler} className='btn btn-primary mt-4 px-4 w-50 text-center'>
          Submit
        </button>
      </div>
    </>
  )
}

export default UpdateTicketModal
